document.addEventListener("DOMContentLoaded", function () {

  (function (){
    //  描述
    let shortDes = document.querySelector(".productView-desc");
    if (shortDes) {
      let learnMore = document.querySelector(".learnmore");
      let learnMoreSpan = document.querySelector(".learnmore span");
      let bl = true;
      learnMore.onclick = function () {
        if (bl === true) {
          shortDes.style.height = "auto";
          shortDes.classList.remove("active");
          learnMore.classList.add("active");
          learnMoreSpan.innerHTML = "Learn Less";
          bl = false;
        } else {
          shortDes.style.height = "72px";
          shortDes.classList.add("active");
          learnMore.classList.remove("active");
          learnMoreSpan.innerHTML = "Learn More";
          bl = true;
        }
      };
    }

    // // 询盘功能
    // const formBtn = document.querySelector(".yg-product-form-btn");
    // const formPopup = document.querySelector(".yg-quote-popup");
    // const formFrame = document.querySelector(".yg-quote-popup > div");
    // let status = true;
    // if (formBtn) {
    //   formBtn.addEventListener("click", (e) => {
    //     if (status === true) {
    //       formPopup.classList.add("active");
    //       formPopup.classList.remove("hide");
    //       status = false;
    //     } else {
    //       formPopup.classList.remove("active");
    //       formPopup.classList.add("hide");
    //       status = true;
    //     }
    //   });

    //   document.addEventListener("click", function (event) {
    //     const isClickInside =
    //         formBtn.contains(event.target) || formFrame.contains(event.target);
    //     if (!isClickInside) {
    //       formPopup.classList.add("hide");
    //       formPopup.classList.remove("active");
    //       status = true;
    //     }
    //   });
    // }

    //  粘性导航
    let navElement = document.querySelector(".new-product-tab");
    let navOffsetTop = navElement.offsetTop;

    let btn = document.querySelector("button.learnmore");
    btn.addEventListener("click", function () {
      navElement = document.querySelector(".new-product-tab");
      navOffsetTop = navElement.offsetTop;
    });

    window.addEventListener("scroll", function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let scroH = scrollTop;
      
      let headerElement = document.querySelector(".section-header-navigation");
      let headerElementMobile = document.querySelector(".section-header-mobile");
      let barElement = document.querySelector(".announcement-bar");
      let height = navOffsetTop + (headerElement?.offsetHeight || 0) + (headerElementMobile?.offsetHeight || 0) + (barElement?.offsetHeight || 0);

      console.log(scroH);
 
      if (window.innerWidth < 767) {
        if (scroH >= height) {
          navElement.style.position = "fixed";
          navElement.style.top = "0";
          navElement.style.zIndex = "3";
        } else if (scroH < height) {
          navElement.style.position = "static";
        }
      } else {
        if (scroH >= height) {
          navElement.classList.add("fixed-position");
          navElement.style.position = "fixed";
        } else if (scroH < height) {
          navElement.classList.remove("fixed-position");
          navElement.style.position = "static";
        }
      }
    });
    let stickyTab = document.querySelectorAll(".new-tab-heading div");
    let productSection = document.querySelectorAll(".scroll-section");

    let stickyHeading1 = document.getElementById("new-product-sticky-heading1");
    let stickyHeading2 = document.getElementById("new-product-sticky-heading2");
    let stickyHeading3 = document.getElementById("new-product-sticky-heading3");
    let stickyHeading4 = document.getElementById("new-product-sticky-heading4");

    let StickyBox1 = document.querySelector(".sticky-box1");
    let StickyBox2 = document.querySelector(".sticky-box2");
    let StickyBox3 = document.querySelector(".sticky-box3");
    let StickyBox4 = document.querySelector(".sticky-box4");

    if (productSection.length > 0) {
      stickyTab.forEach((button) => {
        button.onclick = function () {
          stickyTab.forEach((section) => {
            section.classList.remove("active");
          });
          button.classList.add("active");
        };
      });
    }

    if (stickyHeading1 && StickyBox1) {
      stickyHeading1.addEventListener("click", function (e) {
        StickyBox1.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        e.preventDefault();
      });
    }

    if (stickyHeading2 && StickyBox2) {
      stickyHeading2.addEventListener("click", function (e) {
        StickyBox2.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        e.preventDefault();
      });
    }

    if (stickyHeading3 && StickyBox3) {
      stickyHeading3.addEventListener("click", function (e) {
        StickyBox3.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        e.preventDefault();
      });
    }

    if (stickyHeading4 && StickyBox4) {
      stickyHeading4.addEventListener("click", function (e) {
        StickyBox4.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        e.preventDefault();
      });
    }

    //元字段数据添加空格符
    function addBlank(){
      let metafieldData = document.querySelector(".yg-product-details-text")
      metafieldData.innerHTML = metafieldData.innerHTML.replace(/:/g, ': ');
      metafieldData.innerHTML = metafieldData.innerHTML.replace(/Mode:/i, 'Model:');
    }

    //元字段数据给”•“前添加换行符
    function addLinefeed(dom){
        let elementList = document.querySelectorAll(dom)
        elementList.forEach(function (element){
          //匹配所有”•“并给他的前面添加<br>
          element.innerHTML = element.innerHTML.replace(/([^•])•/g, '$1<br>•')
          console.log('--->', element)

          //判断该br是否是第一个字符，是则删除该br，不是则保留
          let previousSibling = element.querySelector("br").previousSibling
          if (!previousSibling || (previousSibling.nodeType === Node.TEXT_NODE && previousSibling.textContent.trim() === '')) {
            element.querySelector("br").parentNode.removeChild(element.querySelector("br"));
          }
        })
    }

    addBlank()
    addLinefeed(".yg-product-overview-text")
  }())


});
